import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({endPoint: `TestAuth`, method: 'POST', body, token})
}
